module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/image-4-small-9f149a79763b01358e12bb306928ffb6.jpg";